import React, { Component } from 'react';
import uuid from 'uuid';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Tooltip, OverlayTrigger} from 'react-bootstrap';

class D3chart extends Component {

    calcWidth(ref,largest) {
        let width;
        width = (ref/largest) * 100;
        return width;
    }

    render () {
        let unit= "";
        switch (this.props.sc.sensorKey){
            case 'temp':
                unit = "°C";
                break;
            case 'hum':
                unit = "%";
                break;
            case 'noise':
                unit = "dB";
                break;
            case 'light':
                unit = "Lux";
                break;
            case 'no2':
                unit = "kOhm/ppm";
                break;
            case 'co':
                unit = "kOhm/ppm";
                break;
            case 'nets':
                unit = "# networks";
                break;
            default:
                unit= "unknown unit"
        }

        let gridItems;
        let arrLargest;
        let largest;

        arrLargest = this.props.sc.readings.map(largestItem => {
            return largestItem[1];
        })

        if (arrLargest !== 0) {
            largest = Math.max.apply(Math, arrLargest);
            largest = largest.toFixed(2)
        }

        gridItems = this.props.sc.readings.map(gridItem => {
            let datum = new Date (gridItem[0])
            datum = datum.toLocaleString()
            let measure = parseFloat(gridItem[1]).toFixed(2)
            let title = datum + " | " + measure + " " + unit;
            let tooltip = (<Tooltip>{title}</Tooltip>);

            return (
                <li className="barHolder" key={uuid.v4()} >
                    <OverlayTrigger placement="right" overlay={tooltip}>
                      <span className="bar clearfix" style={{width: this.calcWidth(measure,largest) + '%'}}>
                          <span className="barDate">{datum}</span>
                          <span className="barMeasure">{measure} {unit}</span>
                      </span>
                    </OverlayTrigger>
                </li>
            )
        })


        return (
               <div className="d3">
                   <h3>{this.props.sc.sensorKey}</h3>
                   <ul>{gridItems}</ul>
               </div>
        )}
}

D3chart.PropTypes = {
    sensorKey: PropTypes.string,
    readings: PropTypes.array,
}

const mapStateToProps = (state) => {
    return {
        sc: state.scReducer
    }
}

const mapDispatchToProps = () => {
    return {}
}

export default connect (mapStateToProps,mapDispatchToProps)(D3chart)


// WEBPACK FOOTER //
// ./src/containers/D3chart.js